export function waveformCacheKey(version) {
  if (!version?.id) return "";
  return `${version.id}:${version.waveform_url || ""}`;
}

export function createVersionWaveformLoader(loadWaveform) {
  const cache = new Map();

  return async function loadVersionWaveform(version) {
    const key = waveformCacheKey(version);
    if (!key) throw new Error("缺少波形版本信息");
    if (!cache.has(key)) {
      const request = Promise.resolve()
        .then(() => loadWaveform(version))
        .catch((error) => {
          cache.delete(key);
          throw error;
        });
      cache.set(key, request);
    }
    return cache.get(key);
  };
}

export function decodeWaveformPayload(payload) {
  if (payload?.encoding !== "int8-minmax-base64" || !Array.isArray(payload.channels)) return payload;
  const channels = payload.channels.map((channel) => {
    const binary = globalThis.atob(String(channel.peaks_base64 || ""));
    const peaks = [];
    for (let index = 0; index + 1 < binary.length; index += 2) {
      const low = binary.charCodeAt(index);
      const high = binary.charCodeAt(index + 1);
      peaks.push([(low > 127 ? low - 256 : low) / 127, (high > 127 ? high - 256 : high) / 127]);
    }
    return { label: channel.label || "M", peaks };
  });
  return { ...payload, channels, peaks: channels[0]?.peaks || [[0, 0]] };
}

export function isPlaybackAbortError(error) {
  return error?.name === "AbortError"
    || /(?:operation was aborted|play\(\) request was interrupted)/i.test(String(error?.message || ""));
}

export function loudnessMatchDb(currentAnalysis, comparisonAnalysis, limitDb = 12) {
  if (currentAnalysis?.silence || comparisonAnalysis?.silence) return null;
  const currentValue = currentAnalysis?.integrated_lufs;
  const comparisonValue = comparisonAnalysis?.integrated_lufs;
  if (currentValue === null || currentValue === undefined || currentValue === ""
    || comparisonValue === null || comparisonValue === undefined || comparisonValue === "") return null;
  const currentLufs = Number(currentValue);
  const comparisonLufs = Number(comparisonValue);
  if (!Number.isFinite(currentLufs) || !Number.isFinite(comparisonLufs)) return null;
  const limit = Math.max(0, Number(limitDb) || 0);
  return Math.max(-limit, Math.min(limit, currentLufs - comparisonLufs));
}

export function decibelsToGain(decibels) {
  const numeric = Number(decibels);
  return Number.isFinite(numeric) ? 10 ** (numeric / 20) : 1;
}
